
import { PropTypes } from 'prop-types';
import { useEffect } from 'react';
import { FaPhone } from 'react-icons/fa6';
import { IoMail, IoPersonSharp } from 'react-icons/io5';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUnitEnquiresTabData } from '../../redux/slice/unitEnquiriesPage';
import { DecodeHtml } from './../../utils/decodeHtml';

const ContactInfo = ({ name, mobile, email }) => {

    return (


        <div className="flex flex-col gap-5 mb-3">
            {
                name && <span className="text-base font-semibold underline leading-normal flex whitespace-nowrap  items-center ">
                    <div className="w-8">
                        <IoPersonSharp size={20} />
                    </div>
                    {name}</span>
            }
            {
                mobile && <span className="text-base font-normal leading-normal flex items-center  whitespace-nowrap ">
                    <div className="w-8">
                        <FaPhone size={20} />
                    </div>
                    {mobile}</span>
            }
            {
                email && <span className="text-base font-normal leading-normal flex items-center  whitespace-nowrap ">
                    <div className="w-8">
                        <IoMail size={20} />
                    </div>
                    {email}</span>
            }
        </div>
    )
}
ContactInfo.propTypes = {
    mobile: PropTypes.string,
    email: PropTypes.string,
    name: PropTypes.string,
}

const UnitEnquiries = ({ url }) => {

    const state = useSelector(state => state.unitEnquiresTab)
    const dispatch = useDispatch()

    useEffect(() => {

        dispatch(fetchUnitEnquiresTabData(url))

    }, [url,dispatch])

    const uniteEnquires = state?.data?.properties

    const details = DecodeHtml({ html: uniteEnquires?.details?.markup })

    const contactsInfo = uniteEnquires?.contactsEnquiries?.items?.map(item => {
        let info = item?.content?.properties
        return {
            title: info?.label,
            contacts: info?.contacts?.items?.map(contact => {
                let contactInfo = contact?.content?.properties
                return {
                    name: contactInfo?.personName,
                    mobile: contactInfo?.phoneNumber,
                    email: contactInfo?.email
                }
            }
            )
        }
    })

    return (
        <div className='flex flex-col gap-3'>
            <h1 className="w-auto  text-slate-900 text-5xl leading-[3rem] font-bold ">{uniteEnquires?.label}</h1>
            {
                details
            }
            <div className="flex flex-col gap-10">
                {contactsInfo?.map((contactInfo, index) => (
                    <div className="flex flex-col gap-5" key={index}>
                        <h2 className="text-slate-900 text-2xl font-bold">{contactInfo?.title}</h2>
                        {
                            contactInfo?.contacts.map((contact, index) => (
                                <ContactInfo key={index} {...contact} />
                            ))
                        }
                    </div>
                ))}
            </div>

        </div>
    )
}

export default UnitEnquiries